<template>
  <el-container>
    <el-main>
      <el-row>
        <el-col :span="20">
          <el-form :inline="true">
            <el-form-item>
              <el-button type="primary" @click="add">添加角色</el-button>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <el-table :data="records" border>
        <el-table-column label="角色名称" prop="name"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button @click="edit(scope.row)">编辑</el-button>
            <el-button type="danger" @click="del">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-main>
    <el-dialog
      title="添加角色"
      :visible.sync="formVisible"
      width="600px">
      <el-form ref="formData" :model="formData" label-width="100px">
        <el-form-item label="角色名称">
          <el-input v-model="formData.name"></el-input>
        </el-form-item>
        <el-form-item label="角色权限" class="permission-tree">
          <el-checkbox @change="toggleTree">全选/不选</el-checkbox>
          <div class="tree-box">
            <el-tree
              ref="tree"
              :data="permissions"
              :props="props"
              :default-checked-keys="rolePermissions"
              show-checkbox
              default-expand-all
              node-key="id"
              @check="PermissionChange">
            </el-tree>
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="onCancel">取 消</el-button>
        <el-button type="primary" @click="onSave">确 定</el-button>
      </span>
    </el-dialog>
  </el-container>
</template>

<script>
import request from '@/utils/request'
export default {
  name: 'Roles',
  data () {
    return {
      records: [],
      formData: {
        name: '',
        permission_ids: []
      },
      props: {
        label: 'name',
        children: 'children'
      },
      permissions: [],
      rolePermissions: [],
      currentChecked: null,
      formVisible: false
    }
  },
  mounted () {
    this.getPermission()
  },
  methods: {
    getPermission () {
      request.get('permissions').then(res => {
        this.permissions = res.data
        this.getList()
      })
    },
    getList () {
      request.get('roles').then(res => {
        this.records = res.data
      })
    },
    PermissionChange (_data, checked) {
      this.rolePermissions = checked.checkedKeys
    },
    toggleTree (val) {
      this.$refs.tree.setCheckedNodes(val ? this.permissions : [])
      this.rolePermissions = this.$refs.tree.getCheckedKeys()
    },
    ParentChange (data, checked) {
      if (checked.checkedKeys.length > 0) {
        // 取消之前选中的节点
        if (this.currentChecked) {
          this.$refs.tree.setChecked(this.currentChecked, false)
        }
        this.currentChecked = data.id
      } else {
        this.currentChecked = null
      }
    },
    add () {
      this.modalTit = '添加'
      this.formVisible = true
    },
    edit (row) {
      this.modalTit = '编辑'
      this.formData = row
      this.rolePermissions = row.permission_ids
      this.formVisible = true
    },
    onCancel () {
      this.formData = {
        name: '',
        permission_ids: []
      }
      this.$refs.tree.setCheckedNodes([])
      this.formVisible = false
    },
    onSave () {
      this.formData.permission_ids = this.rolePermissions
      const loading = this.$loading({
        lock: true,
        text: '数据加载中',
        spinner: 'el-icon-loading',
        background: 'rgba(255, 255, 255, 0.5)'
      })
      if (this.currentRow) {
        this.formData.parent_id = this.currentRow.id
      }
      if (this.formData.id) {
        request.put(`roles/${this.formData.id}`, this.formData).then(() => {
          loading.close()
          this.formData = {
            name: '',
            permission_ids: []
          }
          this.$refs.tree.setCheckedNodes([])
          this.getList()
          this.formVisible = false
        })
      } else {
        request.post(`roles`, this.formData).then(() => {
          loading.close()
          this.formData = {
            name: '',
            permission_ids: []
          }
          this.$refs.tree.setCheckedNodes([])
          this.getList()
          this.formVisible = false
        })
      }
    },
    del () {
      this.$confirm('确定删除此项吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'info'
      }).then(() => {
        this.$message({
          type: 'success',
          message: '删除成功!'
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    }
  }
}
</script>

<style scoped>
.el-aside {
  border-right: 1px solid #ddd;
}
.list-group li {
  cursor: pointer;
  padding: 0 10px;
}
.list-group li:hover, .list-group li.active {
  background-color: #ecf5ff;
}
.tree-box {
  height: 300px;
  overflow-y: scroll;
}
</style>
